export default __webpack_public_path__ + "static/media/womanWithHeadphones.affaa669.jpg";